import ImageContainer from './ImageContainer'

export default ImageContainer